import * as React from 'react'

import SvgIcon from './SvgIcon'
import { colorMap } from 'bvdash/styles'

export const Actions = props => (
  <SvgIcon
    width={27}
    height={22}
    strokeWidth={0}
    {...props}
    viewBox="0 0 29 22"
  >
    <g transform="translate(-743.000000, -23.000000)">
      <g transform="translate(722.000000, 22.348837)">
        <path d="M38.8827622,17.3188919 L41.7135876,17.7133609 C41.9902365,17.2669322 42.2528482,16.7669533 42.5025925,16.2176657 C42.4335765,16.2028201 37.9317452,15.5771836 37.8615595,15.5671098 C37.8621444,15.56764 37.8621444,15.5681702 37.8627292,15.5681702 C38.233544,15.9043173 38.4376675,16.5930476 38.8827622,17.3188919 M37.2836968,6.2992073 L35.5641458,7.53828557 L34.9991505,6.61679732 C34.577451,5.92806704 33.4264047,6.50651564 33.8492738,7.19630633 L34.7909327,8.73282701 C34.9868679,9.05253784 35.4559427,9.1400209 35.7752879,8.90991394 L38.1025306,7.23289016 C38.7833324,6.74245481 37.9650835,5.80771155 37.2836968,6.2992073 M32.4911795,11.585305 L33.4328384,13.1212955 C33.6287736,13.4415365 34.0978484,13.5290196 34.4171936,13.2983824 L36.7444362,11.6213586 C37.425238,11.1309233 36.6069891,10.19618 35.9256024,10.6876758 L34.2060514,11.9267541 L33.6410561,11.005796 C33.2187718,10.3165355 32.0683103,10.8949841 32.4911795,11.585305 M44.8842291,7.87814401 C44.8146282,7.8654192 39.5506966,7.21009154 39.479926,7.20107813 C39.3588556,7.7143121 39.2325212,8.23178766 39.0974136,8.75403503 C39.1722784,8.77100144 44.4888493,9.43163111 44.5660537,9.44117471 C44.6754265,8.93377295 44.78129,8.41205579 44.8842291,7.87814401 M49.0503385,2.56023426 L32.5332909,0.659465925 C31.9735596,0.593190878 31.4512606,0.930398316 31.3348692,1.43037727 C31.3143983,1.51733013 29.6445623,8.55574009 27.4348808,13.5401538 L29.6129787,13.8943276 C31.3717167,9.81390557 32.7303959,4.75208261 33.2421671,2.72512658 L47.6834709,4.38783495 C46.7195866,10.2301129 44.4274368,18.996976 41.7720758,20.3776178 C39.5840349,21.5138372 37.6586057,18.9646338 36.8415265,17.0585635 C36.7046643,16.7383225 36.3929226,16.5050343 36.0203532,16.4445914 C36.0203532,16.4445914 22.339395,14.2145687 21.8767539,14.1451124 C21.3053249,14.05922 20.9520566,14.4886823 21.0052808,14.8354333 C21.221102,16.2447059 23.0517804,19.4513578 27.0862915,20.2137859 C31.3196623,21.0143885 39.6056755,22.5487883 39.6056755,22.5487883 C40.6958942,22.7534457 41.7170969,22.6765666 42.8523515,22.0859234 C47.5074217,19.6655587 49.7498565,5.29818899 49.9902427,3.66729264 C50.0703715,3.12648826 49.6480872,2.62916031 49.0503385,2.56023426 M37.7878644,12.8970207 L43.470571,13.6552073 C43.6273192,13.1621209 43.7776337,12.6467662 43.9232691,12.1096732 C43.8519136,12.0969484 38.4078386,11.3716343 38.3364831,11.3620907 C38.169207,11.8689622 37.9878938,12.3806056 37.7878644,12.8970207" />
      </g>
    </g>
  </SvgIcon>
)

export const AddConversation = props => (
  <SvgIcon width={17} height={16} {...props} viewBox="0 0 17 16">
    <path d="M4 3.276c.552 0 1 .417 1 .93 0 .515-.448.932-1 .932h-.999c-.55 0-1.001.419-1.001.923v6.53c0 .507.451.923 1.009.923h7.982c.562 0 1.009-.413 1.009-.93v-1.86c0-.514.448-.93 1-.93s1 .416 1 .93v1.86c0 1.549-1.346 2.792-3.009 2.792H3.01C1.35 15.376 0 14.131 0 12.591v-6.53c0-1.534 1.347-2.785 3.001-2.785H4zm7.071-2.135c1.173-1.092 3.067-1.094 4.243 0 1.173 1.092 1.175 2.855 0 3.95l-5.657 5.267c-.14.13-.318.218-.511.254l-3.536.659c-.7.13-1.316-.444-1.176-1.096l.707-3.291a.913.913 0 0 1 .273-.476l5.657-5.267zM13.9 3.774a.882.882 0 0 0 0-1.316 1.048 1.048 0 0 0-1.414 0L7.043 7.525l-.354 1.646 1.768-.33L13.9 3.775z" />
  </SvgIcon>
)
export const Alert = props => (
  <SvgIcon width={20} height={23} {...props} viewBox="0 0 20 23">
    <path d="M7.04 3.278A1 1 0 0 1 7 3a3 3 0 1 1 6 0 1 1 0 0 1-.04.278A7.008 7.008 0 0 1 18 10l.004 4.171A2.995 2.995 0 0 1 20 17c0 1.656-1.34 3-2.995 3h-3.131a4.002 4.002 0 0 1-7.748 0h-3.13A2.993 2.993 0 0 1 0 17a3 3 0 0 1 2-2.83V10a7 7 0 0 1 5.04-6.722zM9 3h2a1 1 0 0 0-2 0zm-.732 17a2 2 0 0 0 3.464 0H8.268zM3 16c-.554 0-1 .447-1 1 0 .557.443 1 .995 1h14.01c.55 0 .995-.447.995-1 0-.557-.443-1-.995-1a1 1 0 0 1-1-.999L16 10c0-2.757-2.24-5-4.998-5H8.998A4.997 4.997 0 0 0 4 10v5a1 1 0 0 1-1 1z" />
  </SvgIcon>
)

export const ArrowDown = props => (
  <SvgIcon width={8} height={5} {...props} viewBox="0 0 8 5">
    <path d="M.155.812C-.163.363.025 0 .575 0h5.882c.55 0 .737.36.412.812L4.07 4.689c-.323.449-.842.451-1.162 0L.155.812z" />
  </SvgIcon>
)

export const ArrowUp = props => (
  <SvgIcon width={8} height={5} {...props} viewBox="0 0 8 5">
    <path d="M.176 3.763c-.343.432-.167.782.377.782h6.006c.55 0 .72-.344.367-.782L4.154.326c-.348-.432-.902-.438-1.25 0L.176 3.763z" />
  </SvgIcon>
)

export const Attach = props => (
  <SvgIcon
    width={props.size}
    height={props.size}
    {...props}
    viewBox="0 0 18 20"
  >
    <path d="M12.26 15.308l-2.096 2.095c-2.327 2.328-5.97 2.519-8.133.356-2.167-2.167-1.977-5.801.356-8.133l3.531-3.532c.044-.044.089-.082.134-.116.031-.043.066-.084.104-.122l1.318-1.318c1.496-1.495 3.967-1.41 5.517.14 1.553 1.552 1.638 4.018.14 5.517l-2.26 2.26c-.944.944-2.358-.47-1.415-1.413l.943-.943a1 1 0 1 1 1.414 1.414l-.943.943-1.414-1.414 2.26-2.261c.695-.695.654-1.896-.139-2.69-.79-.79-1.997-.83-2.689-.139L7.57 7.27a1.007 1.007 0 0 1-.121.104c-.034.046-.073.09-.117.134L6.154 8.687A1 1 0 0 1 4.74 7.273l1.178-1.179.041.041a1 1 0 0 0 1.332 1.332l.041.041-3.531 3.532c-1.583 1.582-1.707 3.954-.356 5.305 1.347 1.347 3.728 1.222 5.305-.356l2.353-2.353.024-.023 2.568-2.568a4.996 4.996 0 0 0 .003-7.074 5.007 5.007 0 0 0-7.074.003L3.799 6.8a1 1 0 0 1-1.414-1.414L5.209 2.56c2.735-2.734 7.173-2.734 9.904-.004a6.996 6.996 0 0 1-.004 9.904l-2.825 2.824a1.018 1.018 0 0 1-.024.024z" />
  </SvgIcon>
)

export const BarCode = props => (
  <SvgIcon width={18} height={17} {...props} viewBox="0 0 18 17">
    <path
      fillRule="evenodd"
      d="M5.584 10.175h1.484V2.963H5.584v7.212zm2.886 0h.901V2.963H8.47v7.212zm-5.3 0h.957V2.963H3.17v7.212zm1.43 0h.446V2.963H4.6v7.212zm7.954 5.248h-1.161v-1.472H6.609v1.472H5.45c-.765 0-1.383.627-1.383 1.39 0 .01 9.87.01 9.87 0 0-.763-.618-1.39-1.382-1.39zm-2.225-5.248h1.485V2.963h-1.485v7.212zm4.694-7.212h-.957v3.296l.957.59V2.963zm-13.61 8.692h15.175V1.413H1.413v10.242zM17.293 0H.708A.708.708 0 0 0 0 .707v11.656c0 .378.307.706.707.706h16.587c.393 0 .706-.32.706-.706V.707A.71.71 0 0 0 17.294 0zm-4.076 5.794V2.963h-.446v2.809c.145-.023.294-.017.446.022zm.188 3.743c.042.17.272.211.368.058l.327-.523.76 1.053c.065.089.192.112.282.044l.28-.201a.2.2 0 0 0 .044-.283L14.71 8.64l.598-.154a.202.202 0 0 0 .056-.368L13.048 6.69a.202.202 0 0 0-.302.221l.66 2.626z"
    />
  </SvgIcon>
)

export const Calendar = props => (
  <SvgIcon width={20} height={20} {...props} viewBox="0 0 20 20">
    <path d="M15 2h2.005A2.996 2.996 0 0 1 20 4.994v12.012A2.994 2.994 0 0 1 17.005 20H2.995A2.996 2.996 0 0 1 0 17.006V4.994A2.994 2.994 0 0 1 2.995 2H5v-.99a1 1 0 1 1 2 0V2h6v-.99a1 1 0 1 1 2 0V2zm3 4V4.994A.996.996 0 0 0 17.005 4H2.995A.994.994 0 0 0 2 4.994V6h16zm0 2H2v9.006c0 .548.446.994.995.994h14.01c.55 0 .995-.445.995-.994V8zM6 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
  </SvgIcon>
)

export const Checkmark = props => (
  <SvgIcon width={20} height={20} {...props} viewBox="0 0 20 20">
    <path d="M18.64 4.975a9.947 9.947 0 0 0-3.636-3.635C13.474.447 11.802 0 9.99 0 8.177 0 6.506.447 4.975 1.34A9.945 9.945 0 0 0 1.34 4.975C.447 6.505 0 8.177 0 9.99c0 1.813.447 3.484 1.34 5.015a9.947 9.947 0 0 0 3.635 3.635c1.53.893 3.202 1.34 5.014 1.34 1.813 0 3.484-.447 5.015-1.34a9.945 9.945 0 0 0 3.635-3.635c.893-1.531 1.34-3.202 1.34-5.015 0-1.812-.447-3.484-1.34-5.014zm-2.173 3.493L9.404 15.53a.814.814 0 0 1-.598.248.8.8 0 0 1-.586-.248l-4.708-4.708a.795.795 0 0 1-.234-.585.81.81 0 0 1 .234-.599l1.183-1.17a.8.8 0 0 1 .586-.248.8.8 0 0 1 .585.248l2.94 2.94 5.307-5.295a.8.8 0 0 1 .585-.247.8.8 0 0 1 .585.247l1.184 1.171a.809.809 0 0 1 .234.598c0 .234-.078.43-.234.586z" />
  </SvgIcon>
)

export const Conversation = props => (
  <SvgIcon width={22} height={21} {...props} viewBox="0 0 22 21">
    <path d="M18 18.567c0 2.1-1.768 2.94-3.387 1.603L11.983 18H8.991C4.028 18 0 13.964 0 9c0-4.971 4.024-9 8.99-9h4.02C17.971 0 22 4.036 22 9a8.995 8.995 0 0 1-4 7.488v2.08zm-1.5-3.5A6.997 6.997 0 0 0 20 9c0-3.86-3.133-7-6.99-7H8.99A6.994 6.994 0 0 0 2 9c0 3.86 3.133 7 6.99 7h3.353a1 1 0 0 1 .636.229l2.907 2.398c.201.167.258.182.172.223-.083.04-.058-.018-.058-.283v-2.634a1 1 0 0 1 .5-.866zM7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
  </SvgIcon>
)

export const ClosePreview = props => (
  <SvgIcon width={35} height={35} {...props} viewBox="0 0 35 35">
    <path
      d="M17.459,16.014l8.239-8.194c0.395-0.391,0.395-1.024,0-1.414c-0.394-0.391-1.034-0.391-1.428,0  l-8.232,8.187L7.73,6.284c-0.394-0.395-1.034-0.395-1.428,0c-0.394,0.396-0.394,1.037,0,1.432l8.302,8.303l-8.332,8.286  c-0.394,0.391-0.394,1.024,0,1.414c0.394,0.391,1.034,0.391,1.428,0l8.325-8.279l8.275,8.276c0.394,0.395,1.034,0.395,1.428,0  c0.394-0.396,0.394-1.037,0-1.432L17.459,16.014z"
      fill="#121313"
      id="Close"
    />
  </SvgIcon>
)

export const CreditCards = props => (
  <SvgIcon width="24" height="17" {...props} viewBox="0 0 24 17">
    <path d="M10.906 12.74H17.323c.59 0 .595-.897-.001-.897h-6.416c-.606-.003-.57.897 0 .897zM22.73 8.418H9.302V7.59c0-.32.257-.579.574-.577h12.278c.318 0 .575.257.575.575v.829zm0 6.26c0 .319-.255.576-.575.576H9.876a.574.574 0 0 1-.573-.533l-.001-4.043h13.427v4zm-.575-8.934H9.876c-1.02 0-1.845.826-1.847 1.844.003 6.626 0 7.115 0 7.115l.001.013a1.845 1.845 0 0 0 1.846 1.808h12.278c1.02 0 1.846-.825 1.846-1.847V7.59c0-1.02-.825-1.845-1.846-1.845zM5.406 8.608l-1.344.489a.738.738 0 0 1-.946-.441l-.327-.9a.734.734 0 0 1 .44-.948l1.34-.488a.739.739 0 0 1 .95.44l.327.901a.743.743 0 0 1-.44.947zm10.998-3.866L15.12 1.216A1.844 1.844 0 0 0 12.753.113L1.216 4.311A1.844 1.844 0 0 0 .114 6.677l2.425 6.663a1.847 1.847 0 0 0 2.365 1.104l2.126-.774-.002-2.869-2.39.87c-.55.206-.866-.637-.304-.843l2.694-.98c0-.084-.002-2.245.003-2.329a2.847 2.847 0 0 1 2.844-2.777h6.529z" />
  </SvgIcon>
)

export const Cross = props => (
  <SvgIcon width={20} height={20} {...props} viewBox="0 0 18 18">
    <path d="M16.268 16.148a1.452 1.452 0 0 1-2.054 0l-5.392-5.393-5.65 5.649A1.452 1.452 0 1 1 1.12 14.35l5.649-5.649L1.375 3.31A1.452 1.452 0 1 1 3.43 1.255l5.393 5.392 5.135-5.135a1.452 1.452 0 1 1 2.054 2.054L10.876 8.7l5.392 5.393a1.452 1.452 0 0 1 0 2.054z" />
  </SvgIcon>
)

export const CrossO = props => (
  <SvgIcon width={12} height={12} {...props} viewBox="0 0 12 12">
    <path
      fill="#FF585B"
      fillRule="nonzero"
      d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm3.31 7.782L7.781 9.309 6 7.527 4.218 9.31 2.691 7.782 4.473 6 2.69 4.218l1.527-1.527L6 4.473 7.782 2.69l1.527 1.527L7.527 6 9.31 7.782z"
    />
  </SvgIcon>
)

export const Danger = props => (
  <SvgIcon width={4} height={18} {...props} viewBox="0 0 4 18">
    <path d="M.156 1.875A1.705 1.705 0 0 1 1.883 0h.234c1.04 0 1.813.844 1.727 1.875l-.76 9.123A1.106 1.106 0 0 1 2 12a1.114 1.114 0 0 1-1.084-1.002l-.76-9.123zM0 16c0-1.105.888-2 2-2 1.105 0 2 .888 2 2 0 1.105-.888 2-2 2-1.105 0-2-.888-2-2z" />
  </SvgIcon>
)

export const Doc = props => (
  <SvgIcon width="18" height="22" {...props} viewBox="0 0 18 22">
    <defs>
      <rect id="b" width="401.91" height="316" x="998" y="237" rx="5" />
      <filter
        id="a"
        width="102.7%"
        height="103.5%"
        x="-1.4%"
        y="-1.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.14 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1023 -422)" />
      <g fillRule="nonzero">
        <path
          fill="#E9E9E0"
          d="M12.676 0H.803C.473 0 .205.257.205.757v20.85c0 .136.267.393.598.393h16.394c.33 0 .598-.257.598-.393V5.1c0-.274-.038-.362-.105-.427L12.93.101A.37.37 0 0 0 12.676 0z"
        />
        <path fill="#D9D7CA" d="M12.886.06v4.654h4.848z" />
        <path
          fill="#00A8F2"
          d="M5.114 5.107H2.659a.401.401 0 0 1-.409-.393c0-.217.183-.393.41-.393h2.454c.225 0 .409.176.409.393a.401.401 0 0 1-.41.393zM6.34 7.071H2.66a.401.401 0 0 1-.41-.392c0-.217.183-.393.41-.393h3.68c.227 0 .41.176.41.393a.401.401 0 0 1-.41.392zM7.977 7.071a.44.44 0 0 1-.29-.114.405.405 0 0 1-.119-.278c0-.103.045-.205.119-.28a.441.441 0 0 1 .58 0 .405.405 0 0 1 .12.28.405.405 0 0 1-.12.278.44.44 0 0 1-.29.114zM12.886 7.071H9.614a.401.401 0 0 1-.41-.392c0-.217.184-.393.41-.393h3.272c.226 0 .41.176.41.393a.401.401 0 0 1-.41.392zM2.66 12.964a.44.44 0 0 1-.291-.114.405.405 0 0 1-.119-.279c0-.102.045-.204.119-.278a.441.441 0 0 1 .58 0 .398.398 0 0 1 .12.278.405.405 0 0 1-.12.28.44.44 0 0 1-.29.113zM7.568 12.964H4.295a.401.401 0 0 1-.409-.393c0-.216.184-.392.41-.392h3.272c.226 0 .41.176.41.392a.401.401 0 0 1-.41.393zM15.34 7.071h-.817a.401.401 0 0 1-.41-.392c0-.217.184-.393.41-.393h.818c.226 0 .409.176.409.393a.401.401 0 0 1-.41.392zM11.66 9.036h-9a.401.401 0 0 1-.41-.393c0-.217.183-.393.41-.393h9c.225 0 .408.176.408.393a.401.401 0 0 1-.409.393zM15.34 9.036h-2.454a.401.401 0 0 1-.409-.393c0-.217.184-.393.41-.393h2.454c.226 0 .409.176.409.393a.401.401 0 0 1-.41.393zM4.295 11H2.66a.401.401 0 0 1-.409-.393c0-.217.183-.393.41-.393h1.635c.226 0 .41.176.41.393a.401.401 0 0 1-.41.393zM10.023 11H5.932a.401.401 0 0 1-.41-.393c0-.217.184-.393.41-.393h4.09c.227 0 .41.176.41.393a.401.401 0 0 1-.41.393zM15.34 11h-3.68a.401.401 0 0 1-.41-.393c0-.217.183-.393.41-.393h3.68c.227 0 .41.176.41.393a.401.401 0 0 1-.41.393zM17.197 22H.803a.587.587 0 0 1-.598-.575v-6.104h17.59v6.104a.587.587 0 0 1-.598.575z"
        />
        <g fill="#FFF">
          <path d="M7.16 18.732a2.8 2.8 0 0 1-.11.835 2.04 2.04 0 0 1-.277.58 1.395 1.395 0 0 1-.378.369c-.14.09-.275.156-.405.201-.13.045-.25.074-.358.086a2.483 2.483 0 0 1-.24.018h-1.56v-3.958h1.24c.348 0 .652.053.915.158.263.106.481.247.655.422.173.175.302.375.388.599.086.223.13.454.13.69zM5.167 20.35c.455 0 .783-.14.984-.419.202-.28.302-.684.302-1.214 0-.164-.02-.328-.061-.489a1.032 1.032 0 0 0-.238-.437 1.256 1.256 0 0 0-.478-.317c-.201-.08-.462-.121-.783-.121h-.392v2.997h.666zM11.24 18.823c0 .333-.044.627-.132.881a1.777 1.777 0 0 1-.363.634 1.52 1.52 0 0 1-.543.381 1.754 1.754 0 0 1-.68.13c-.245 0-.472-.044-.679-.13a1.52 1.52 0 0 1-.542-.381 1.78 1.78 0 0 1-.364-.634 2.703 2.703 0 0 1-.131-.88c0-.333.044-.626.131-.879.088-.252.209-.462.364-.63.154-.17.335-.297.542-.385a1.72 1.72 0 0 1 .68-.131c.246 0 .472.043.68.131.206.088.387.216.542.384.154.169.275.38.363.631.088.253.132.545.132.878zm-1.734 1.5c.137 0 .269-.027.394-.079a.877.877 0 0 0 .335-.255 1.27 1.27 0 0 0 .232-.464c.056-.192.086-.425.09-.701a2.637 2.637 0 0 0-.087-.685 1.35 1.35 0 0 0-.224-.465.854.854 0 0 0-.707-.343c-.138 0-.27.024-.395.075a.84.84 0 0 0-.335.255c-.099.12-.176.274-.232.464-.056.19-.086.423-.09.698.004.27.033.498.087.688.054.19.129.344.224.465a.89.89 0 0 0 .324.263c.122.055.25.083.384.083zM14.976 20.419c-.153.143-.327.25-.52.322a1.787 1.787 0 0 1-.627.107c-.246 0-.472-.043-.68-.129a1.52 1.52 0 0 1-.542-.381 1.78 1.78 0 0 1-.363-.634 2.703 2.703 0 0 1-.132-.88c0-.333.044-.626.132-.879.087-.252.208-.462.363-.63.155-.17.337-.297.546-.385.208-.088.434-.131.676-.131.224 0 .433.035.627.107s.367.179.52.322l-.465.398a.846.846 0 0 0-.31-.226.932.932 0 0 0-.355-.07c-.138 0-.27.025-.395.075a.84.84 0 0 0-.335.255c-.1.12-.176.275-.232.465-.056.19-.086.422-.09.698.004.269.033.498.087.687.054.19.128.345.224.465a.89.89 0 0 0 .324.263.905.905 0 0 0 .384.084c.134 0 .26-.024.377-.07a.886.886 0 0 0 .322-.226l.464.393z" />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Download = props => (
  <SvgIcon width={35} height={35} {...props} viewBox="0 0 35 35">
    <path d="M16.707,7.404C16.518,7.216,16.259,7.121,16,7.121s-0.518,0.095-0.707,0.283L13,9.697V3c0-0.552-0.448-1-1-1s-1,0.448-1,1   v6.697L8.707,7.404C8.518,7.216,8.267,7.111,8,7.111S7.482,7.216,7.293,7.404c-0.39,0.39-0.39,1.024,0,1.414L12,13.5l4.709-4.684   C17.097,8.429,17.097,7.794,16.707,7.404z" />
    <path d="M20.987,16c0-0.105-0.004-0.211-0.039-0.316l-2-6C18.812,9.275,18.431,9,18,9h-0.219c-0.094,0.188-0.21,0.368-0.367,0.525   L15.932,11h1.348l1.667,5H5.054l1.667-5h1.348L6.586,9.525C6.429,9.368,6.312,9.188,6.219,9H6C5.569,9,5.188,9.275,5.052,9.684   l-2,6C3.017,15.789,3.013,15.895,3.013,16C3,16,3,21,3,21c0,0.553,0.447,1,1,1h16c0.553,0,1-0.447,1-1C21,21,21,16,20.987,16z" />
  </SvgIcon>
)

export const Email = props => (
  <SvgIcon width={20} height={18} {...props} viewBox="0 0 20 18">
    <path d="M2 6.349v7.652C2 15.106 2.892 16 3.993 16h12.014C17.1 16 18 15.1 18 14.001V6.247l-5.82 5.857a2.907 2.907 0 0 1-4.206.12L2 6.35zm14.065-.993A.998.998 0 0 1 16 5V2H4v3c0 .15-.033.292-.092.42l5.468 5.378c.378.372.968.354 1.354-.07l5.335-5.372zM18 3.17c1.166.41 2 1.524 2 2.834V14A4.004 4.004 0 0 1 16.007 18H3.993A3.995 3.995 0 0 1 0 14.001V6.003C0 4.698.838 3.584 2 3.17V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2.17zM6 5c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 5z" />
  </SvgIcon>
)

export const Envelope = props => (
  <SvgIcon
    width={19}
    height={14}
    strokeWidth={0.3}
    {...props}
    viewBox="0 0 19 14"
  >
    <path d="M18.793 13.06c0-.04.042-.123.042-.164V1.537v-.083-.082s0-.042-.042-.042c0-.04-.04-.04-.04-.082l-.042-.041-.041-.042s-.042-.041-.083-.041c0 0-.041 0-.041-.041H18.339h-.041L.743 1.04H.537.496s-.042 0-.042.042c-.041 0-.041.04-.082.04l-.042.042-.04.042c0 .04-.042.04-.042.082 0 0 0 .041-.041.041v11.648c0 .042 0 .124.04.165 0 0 0 .042.042.042 0 .041.041.082.083.124l.041.041c.041.041.083.041.124.083 0 0 .041 0 .041.04.042.042.124.042.165.042h17.555c.082 0 .124 0 .165-.041 0 0 .041 0 .041-.041a.089.089 0 0 0 .083-.083l.041-.041c.042-.042.042-.083.083-.083.041-.124.041-.124.082-.165-.04 0 0 0 0 0zM17.761 2.736v9.17l-5.494-4.048 5.494-5.122zm-6.65 4.75L9.252 9.22l-7.27-7.187 14.994.04-5.865 5.412zm-4.709.372L1.24 11.822V2.735l5.163 5.122zM2.23 12.359L7.146 8.6l1.693 1.693a.475.475 0 0 0 .702 0l1.9-1.776 5.205 3.842H2.23z" />
  </SvgIcon>
)

export const Eye = props => (
  <SvgIcon width={25} height={15} {...props} viewBox="100 100 25 15">
    <path d="M112.496 100.037c-4.775 0-9.105 2.616-12.3 6.865a.992.992 0 0 0 0 1.183c3.195 4.254 7.525 6.87 12.3 6.87s9.105-2.616 12.3-6.865a.992.992 0 0 0 0-1.183c-3.195-4.254-7.525-6.87-12.3-6.87zm.343 12.712a5.263 5.263 0 0 1-.685-10.505 5.263 5.263 0 0 1 5.588 5.595c-.17 2.616-2.29 4.74-4.903 4.91zm-.159-2.427a2.828 2.828 0 0 1-3.006-3.01 2.844 2.844 0 0 1 2.643-2.647 2.828 2.828 0 0 1 3.006 3.01 2.844 2.844 0 0 1-2.643 2.647z" />
  </SvgIcon>
)

export const Export = props => (
  <SvgIcon width={16} height={17} {...props} viewBox="0 0 16 17">
    <path d="M13.206 2.134l-2.325-.317c-.484-.066-.93-.512-.996-.996-.066-.484.273-.823.757-.757l3.714.507c.484.067.93.512.996.996l.513 3.762c.067.484-.272.822-.756.756-.484-.066-.93-.512-.996-.996l-.124-.91L9.66 8.508a.995.995 0 0 1-1.411-.002.995.995 0 0 1-.003-1.411l4.96-4.96zm.508 7.11c0-.553.341-1 .762-1s.762.447.762 1v3.924c0 1.66-1.02 3.009-2.282 3.009H2.282C1.021 16.177 0 14.831 0 13.171V3.183C0 1.523 1.02.177 2.285.177h6.138c.421 0 .762.448.762 1s-.34 1-.762 1H2.285c-.421 0-.761.449-.761 1.006v9.988c0 .557.34 1.006.758 1.006h10.674c.418 0 .758-.45.758-1.009V9.243zM3.048 5.176c0-.552.452-1 1-1h1.808c.553 0 1.001.444 1.001 1 0 .552-.452 1-1 1H4.048c-.553 0-1.001-.444-1.001-1zm0 3c0-.552.452-1 1-1h1.808c.553 0 1.001.444 1.001 1 0 .552-.452 1-1 1H4.048c-.553 0-1.001-.444-1.001-1zm0 3c0-.552.452-1 1-1h1.808c.553 0 1.001.444 1.001 1 0 .552-.452 1-1 1H4.048c-.553 0-1.001-.444-1.001-1z" />
  </SvgIcon>
)

export const File = props => (
  <SvgIcon
    width="24"
    height="24"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1px"
    {...props}
    viewBox="0 0 24 24"
  >
    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <polyline points="13 2 13 9 20 9" />
  </SvgIcon>
)

export const Flag = props => (
  <SvgIcon width={25} height={25} {...props} viewBox="0 0 25 25">
    <path d="M7.173 8.1a.56.56 0 1 0-.29-1.08l-1.468.393a.56.56 0 0 0 .145 1.1c.105 0 .18-.029.338-.07l2.663 9.94h1.16L6.98 8.153l.193-.052zm11.005.337s-1.03 1.27-2.946.903c-1.94-.372-1.924-1.022-3.859-1.654-1.934-.632-3.53.889-3.53.889l1.821 6.843s1.597-1.52 3.531-.889c1.934.632 1.918 1.282 3.859 1.654C18.969 16.55 20 15.28 20 15.28l-1.822-6.843z" />
  </SvgIcon>
)

export const Filter = props => (
  <SvgIcon width={18} height={22} {...props} viewBox="0 0 18 22">
    <path d="M6.836 10.396c.19.251.296.58.296.919v10.004c0 .602.6.908.955.484l2.304-3.198c.308-.448.478-.67.478-1.113v-6.175c0-.34.107-.668.296-.919l6.611-8.69C18.272 1.058 17.89 0 17.158 0H.843C.11 0-.273 1.055.224 1.709l6.612 8.687z" />
  </SvgIcon>
)

export const Folder = props => (
  <SvgIcon width={32} height={32} {...props} viewBox="0 0 64 54">
    <path
      d="M46,15v-4  c0-1.104-0.896-2-2-2c0,0-24.648,0-26,0c-1.469,0-2.484-4-4-4H3C1.896,5,1,5.896,1,7v4v29v4c0,1.104,0.896,2,2,2h39  c1.104,0,2-0.896,2-2"
      fill="none"
      stroke="#344775"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2.5"
    />
    <path
      d="M1,44l5-27  c0-1.104,0.896-2,2-2h39c1.104,0,2,0.896,2,2l-5,27"
      fill="none"
      stroke="#344775"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2.5"
    />
  </SvgIcon>
)

export const Hazard = props => (
  <SvgIcon width={25} height={25} {...props} viewBox="0 0 25 25">
    <path d="M11.66 10.553l.33 3.093c.058.614.962.615 1.02 0l.33-3.093a.844.844 0 1 0-1.68 0zm.84 3.998a.692.692 0 1 0 0 1.384.692.692 0 0 0 0-1.384zm-5.544 2.2L12.5 7.15l5.543 9.602H6.956zm12.932.331L13.12 5.358a.715.715 0 0 0-1.24 0l-6.784 11.75a.707.707 0 0 0 .62 1.065h13.568a.712.712 0 0 0 .604-1.09z" />
  </SvgIcon>
)

export const Info = props => {
  return (
    <SvgIcon width={32} height={32} {...props} viewBox="0 -2 32 32">
      <defs>
        <circle id="b" cx="11" cy="11" r="11" />
        <filter
          id="a"
          width="168.2%"
          height="168.2%"
          x="-34.1%"
          y="-25%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius=".5"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dy="2"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="2"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.1 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(5 3)">
          <circle fill="#000" filter="url(#a)" cx="11" cy="11" r="11" />
          <circle fill="#fff" stroke="#dcdfe2" cx="11" cy="11" r="11" />
        </g>
        <path
          fill="#b0b6c1"
          d="M17.25 17.757c0 .686-.555 1.243-1.25 1.243-.69 0-1.25-.554-1.25-1.243v-3.514c0-.686.555-1.243 1.25-1.243.69 0 1.25.554 1.25 1.243v3.514zM17.5 10c0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5 0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5z"
        />
      </g>
    </SvgIcon>
  )
}

export const Jpg = props => (
  <SvgIcon width="18" height="22" viewBox="0 0 18 22">
    <defs>
      <rect id="b" width="401.91" height="316" x="998" y="237" rx="5" />
      <filter
        id="a"
        width="102.7%"
        height="103.5%"
        x="-1.4%"
        y="-1.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.14 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1023 -386)" />
      <g fillRule="nonzero">
        <path
          fill="#E9E9E0"
          d="M12.676 0H.803C.473 0 .205.257.205.757v20.85c0 .136.267.393.598.393h16.394c.33 0 .598-.257.598-.393V5.1c0-.274-.038-.362-.105-.427L12.93.101A.37.37 0 0 0 12.676 0z"
        />
        <path fill="#D9D7CA" d="M12.886.06v4.654h4.848z" />
        <ellipse cx="5.29" cy="5.669" fill="#F3D55B" rx="1.869" ry="1.795" />
        <path
          fill="#26B99A"
          d="M.205 15.321h17.59V11l-4.09-3.732-4.296 4.518-2.243-2.154z"
        />
        <path
          fill="#14A085"
          d="M17.197 22H.803a.587.587 0 0 1-.598-.575v-6.104h17.59v6.104a.587.587 0 0 1-.598.575z"
        />
        <g fill="#FFF">
          <path d="M6.31 16.755v3.084a.953.953 0 0 1-.106.47.854.854 0 0 1-.285.305c-.12.077-.256.131-.411.161-.155.031-.314.046-.478.046a2.533 2.533 0 0 1-.63-.1 3.798 3.798 0 0 1-.338-.114 1.252 1.252 0 0 1-.274-.145l.285-.435c.038.024.09.05.16.077.069.027.144.052.226.076.082.023.168.043.258.061.09.018.173.027.251.027.198 0 .355-.037.473-.11.117-.073.18-.198.187-.373v-3.03h.683zM7.983 20.795h-.671v-3.96h1.185c.175 0 .349.028.52.081.172.054.325.135.462.242.136.107.246.237.33.39.084.151.126.322.126.512 0 .201-.036.383-.107.546-.07.163-.17.3-.296.41a1.35 1.35 0 0 1-.459.258c-.179.061-.377.091-.593.091h-.497v1.43zm0-3.47v1.568h.615a.758.758 0 0 0 .244-.04.618.618 0 0 0 .22-.132.64.64 0 0 0 .163-.255 1.164 1.164 0 0 0 .033-.628.631.631 0 0 0-.358-.435.932.932 0 0 0-.414-.078h-.503zM13.705 18.753v1.531a1.187 1.187 0 0 1-.288.255 1.79 1.79 0 0 1-.7.255 2.488 2.488 0 0 1-.371.027c-.247 0-.473-.042-.68-.128a1.52 1.52 0 0 1-.542-.382 1.78 1.78 0 0 1-.364-.634 2.703 2.703 0 0 1-.131-.88c0-.333.043-.626.13-.878.088-.253.21-.463.365-.631.154-.169.336-.297.545-.385.209-.088.434-.131.677-.131.223 0 .432.036.626.107.194.072.367.18.52.322l-.465.398a.796.796 0 0 0-.307-.226.954.954 0 0 0-.358-.07c-.138 0-.27.025-.394.075a.84.84 0 0 0-.336.255c-.099.12-.176.275-.232.465a2.803 2.803 0 0 0-.003 1.396c.054.197.129.358.224.484a.942.942 0 0 0 .324.279c.122.06.25.091.384.091a2.188 2.188 0 0 0 .372-.035 1.39 1.39 0 0 0 .198-.051.285.285 0 0 0 .14-.091v-.978h-.7v-.44h1.366z" />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Lightning = props => (
  <SvgIcon
    width={25}
    height={25}
    {...props}
    strokeWidth="0.2"
    viewBox="0 0 25 25"
  >
    <path d="M12.333 3.667v7.5l3.333-.834-4 10v-7.5l-3.333.834 4-10zm0-1.667c-.496 0-.962.348-1.192.92l-4 10c-.228.57-.176 1.252.133 1.757.255.419.649.656 1.06.656.086 0 .173-.011.26-.032l1.74-.435v5.467c0 .774.425 1.444 1.027 1.621.102.031.204.046.306.046.495 0 .961-.348 1.192-.92l4-10c.228-.57.176-1.252-.133-1.758-.255-.418-.649-.655-1.06-.655-.086 0-.174.01-.262.032l-1.738.435V3.667c0-.774-.426-1.444-1.026-1.622A1.059 1.059 0 0 0 12.333 2z" />
  </SvgIcon>
)

export const List = props => (
  <SvgIcon width={18} height={12} viewBox="0 0 18 12">
    <path
      fillRule="evenodd"
      d="M17.337 4.09H5.4c-.366 0-.663.276-.663.615v.818c0 .338.297.613.663.613h11.937c.366 0 .663-.275.663-.613v-.818c0-.34-.297-.614-.663-.614m0-4.091H5.4c-.366 0-.663.275-.663.614v.818c0 .339.297.613.663.613h11.937c.366 0 .663-.274.663-.613V.614c0-.34-.297-.614-.663-.614m0 9.205H5.4c-.366 0-.663.274-.663.613v.818c0 .34.297.614.663.614h11.937c.366 0 .663-.275.663-.614v-.818c0-.339-.297-.613-.663-.613M1.327 0H.567C.255 0 0 .275 0 .614v.818c0 .339.255.613.568.613h.758c.314 0 .569-.274.569-.613V.614C1.895.274 1.64 0 1.326 0m0 9.205H.568c-.313 0-.568.274-.568.613v.818c0 .34.255.614.568.614h.758c.314 0 .569-.275.569-.614v-.818c0-.339-.255-.613-.569-.613m0-5.114H.568c-.313 0-.568.275-.568.614v.818c0 .338.255.613.568.613h.758c.314 0 .569-.275.569-.613v-.818c0-.34-.255-.614-.569-.614"
    />
  </SvgIcon>
)

export const Lock = props => (
  <SvgIcon width={25} height={25} {...props} viewBox="0 0 25 25">
    <path d="M13.07 14.918v1.44h-1.855v-1.44c-.43-.245-.713-.655-.713-1.121 0-.751.735-1.36 1.64-1.36.906 0 1.64.609 1.64 1.36 0 .466-.283.876-.713 1.12zm4.89-4.44H6.326c-.33 0-.612.215-.612.507v7.08c0 .286.277.506.612.506H17.96c.336 0 .611-.224.611-.507v-7.08c0-.279-.27-.507-.611-.507zM9.287 8.615c.003-1.308 1.279-2.364 2.853-2.367 1.578.003 2.853 1.06 2.857 2.367V9.66h2.37V8.616c0-2.392-2.34-4.33-5.227-4.33-2.886 0-5.224 1.938-5.224 4.33v1.043h2.37V8.616z" />
  </SvgIcon>
)

export const Logo = props => (
  <SvgIcon
    color="transparent"
    width={155}
    height={43}
    {...props}
    viewBox="0 0 155 43"
  >
    <defs>
      <linearGradient id="a" x1="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor="#FFD65B" />
        <stop offset="100%" stopColor="#FFE45B" />
      </linearGradient>
      <linearGradient id="b" x1="0%" y1="50%" y2="50%">
        <stop offset="0%" stopColor="#FFCF46" />
        <stop offset="100%" stopColor="#FF9F3E" />
      </linearGradient>
      <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF6364" />
        <stop offset="100%" stopColor="#FF5657" />
      </linearGradient>
      <linearGradient id="d" x1="50%" x2="50%" y1="1.108%" y2="98.778%">
        <stop offset="0%" stopColor="#43A9FF" />
        <stop offset="100%" stopColor="#6ABBFF" />
      </linearGradient>
      <linearGradient id="e" x1="89.345%" x2="9.105%" y1="59.105%" y2="59.105%">
        <stop offset="0%" stopColor="#517DF0" />
        <stop offset="100%" stopColor="#314CDA" />
      </linearGradient>
      <linearGradient id="f" x1="1.633%" x2="98.367%" y1="48.367%" y2="48.367%">
        <stop offset="0%" stopColor="#FF94BF" />
        <stop offset="100%" stopColor="#FF7DB1" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-4 -3)">
        <path
          fill="url(#a)"
          d="M7.624 38.956a21.439 21.439 0 0 0 15.184 6.273 21.44 21.44 0 0 0 15.202-6.291L22.826 23.754 7.624 38.956z"
          transform="rotate(20 22.77 34.538)"
        />
        <path
          fill="url(#b)"
          d="M10.109 30.238a14.23 14.23 0 0 0 9.908 3.977c3.968 0 7.554-1.605 10.123-4.19l-9.91-9.909L10.11 30.238z"
          transform="rotate(66 20.077 27.212)"
        />
        <path
          fill="url(#c)"
          d="M37.64 9.967A16.172 16.172 0 0 1 42.4 21.44c0 4.513-1.848 8.596-4.833 11.544L26.096 21.512 37.64 9.967z"
          transform="rotate(-20 34.202 21.43)"
        />
        <path
          fill="url(#d)"
          d="M12.609 33.302c-3.842-3.836-6.21-9.09-6.21-14.886 0-5.804 2.375-11.065 6.225-14.902L27.51 18.4 12.609 33.302z"
          transform="rotate(32 17 18.455)"
        />
        <path
          fill="#3AA3DE"
          d="M12.759 27.075a14.193 14.193 0 0 1 .53-7.682l12.297 4.72-12.827 2.962z"
        />
        <path
          fill="url(#e)"
          d="M13.126 11.096a19.068 19.068 0 0 1 13.492-5.54c5.173 0 9.861 2.034 13.281 5.333L26.41 24.38 13.127 11.096z"
        />
        <path
          fill="#4B4481"
          d="M38.118 12.671a16.31 16.31 0 0 0-4.581-3.2l-6.798 14.58 11.379-11.38z"
        />
        <path
          fill="#2B42B2"
          d="M25.905 23.875l-4.09-17.717a19.016 19.016 0 0 0-8.689 4.938l12.779 12.779z"
        />
        <path
          fill="url(#f)"
          d="M20.362 26.078a19.068 19.068 0 0 1 13.492-5.54c5.173 0 9.861 2.035 13.281 5.334l-13.49 13.49-13.283-13.284z"
          transform="rotate(130 33.795 29.904)"
        />
        <path
          fill="#FF6DA8"
          d="M26.865 25.257l7.37 15.804A19.006 19.006 0 0 1 28.39 42.7l-1.526-17.442z"
        />
        <path
          fill="#F15454"
          d="M42.784 22.304a16.226 16.226 0 0 1-1.493 8.86l-14.5-6.761-.035-.39.149-.32 15.879-1.389z"
        />
        <ellipse cx="26.4" cy="24.206" fill="#FFF" rx="4.8" ry="4.762" />
      </g>
      <text
        fill="#344775"
        fontFamily="Sailec"
        fontSize="20"
        fontWeight="700"
        letterSpacing="2"
        transform="translate(-4 -3)"
      >
        <tspan x="60" y="32">
          BVDASH
        </tspan>
      </text>
    </g>
  </SvgIcon>
)
export const Logout = props => (
  <SvgIcon
    width={16}
    height={18}
    {...props}
    strokeWidth={2}
    viewBox="0 0 16 18"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 13.08v.928A2.996 2.996 0 0 1 11.997 17H4.003A3 3 0 0 1 1 13.99V4.01A3.005 3.005 0 0 1 4.003 1h7.994A3 3 0 0 1 15 3.992V5.03M15 9H5.983M9.005 6.033C8.912 6.126 5.983 9 5.983 9M9.029 12.033L5.983 9" />
    </g>
  </SvgIcon>
)
export const Mobile = props => (
  <SvgIcon width={14} height={18} {...props} viewBox="0 0 14 18">
    <path d="M2 2.994v12.012c0 .546.45.994 1.009.994h7.982c.558 0 1.009-.448 1.009-.994V2.994C12 2.448 11.55 2 10.991 2H3.01C2.45 2 2 2.448 2 2.994zm-2 0A3.003 3.003 0 0 1 3.009 0h7.982C12.651 0 14 1.34 14 2.994v12.012A3.003 3.003 0 0 1 10.991 18H3.01A3.002 3.002 0 0 1 0 15.006V2.994zM5 14c0 .556.452 1 1.01 1h1.98a1 1 0 1 0 0-2H6.01A1 1 0 0 0 5 14z" />
  </SvgIcon>
)

export const Money = props => (
  <SvgIcon width={14} height={20} {...props} viewBox="0 0 14 20">
    <path
      fillRule="evenodd"
      d="M4.045 5.957a.344.344 0 0 0-.345.346v1.546c0 .199.16.347.345.347h5.621c.19 0 .345-.153.345-.347V6.303a.345.345 0 0 0-.345-.346h-5.62zm3.191 10.78v.847h-.731v-.848h-.01c-.944-.098-1.73-.588-1.952-1.56l1.23-.277c.161.597.599.793 1.178.793.392 0 .891-.134.891-.605 0-.473-.642-.562-.989-.634-1.018-.214-2.016-.517-2.016-1.757 0-.971.723-1.65 1.65-1.774h.018v-.714h.731v.705c.847.062 1.525.49 1.801 1.32l-1.123.374c-.17-.48-.473-.669-.981-.669-.357 0-.785.082-.785.527 0 .419.5.508.82.58.708.144 2.23.36 2.23 1.82 0 1.104-.927 1.81-1.962 1.871zM9.519 9.06H4.214C2.498 10.446.03 12.744 0 14.934c-.007 1.728.796 3.045 2.062 3.866C3.326 19.628 5.02 20 6.87 20c1.845-.001 3.54-.372 4.803-1.2 1.267-.82 2.069-2.138 2.061-3.866-.03-2.184-2.492-4.49-4.214-5.874zM4.07 5.092h5.427c.79-.634 2.56-2.117 2.617-3.104.01-.49-.697-1.085-1.72-.75-.964.316-1.055 2.05-2.367-.088C7.593.446 7.014-.039 6.18.002c-1.62.082-1.024 1.282-1.798 1.712-.584.324-1.93-.699-2.69.13H1.69c-.747.883 1.443 2.584 2.38 3.248z"
    />
  </SvgIcon>
)

export const More = props => (
  <SvgIcon
    color={props.color || colorMap.cadetBlue}
    width={16}
    height={4}
    {...props}
    viewBox="0 0 16 4"
  >
    <path d="M8 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM2 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
  </SvgIcon>
)
export const Mute = props => (
  <SvgIcon width={16} height={17} {...props} viewBox="0 0 16 17">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-376.000000, -212.000000)" fill="#23A2F5">
        <g transform="translate(40.000000, 132.000000)">
          <g transform="translate(0.000000, -7.000000)">
            <g transform="translate(0.000000, 60.000000)">
              <path d="M349.570363,29.0916121 L348.117866,30.3510312 C349.024941,31.8549834 349.547331,33.6162099 349.547331,35.499948 C349.547331,37.3841761 349.024941,39.1458927 348.117866,40.6488647 L349.570363,41.9082838 C350.757255,40.058849 351.44871,37.8609912 351.44871,35.499948 C351.44871,33.1393948 350.757255,30.941047 349.570363,29.0916121 M344.051951,27.2103243 L340.040432,31.2223336 L336.713017,31.2223336 C336.31902,31.2223336 336,31.5413537 336,31.935351 L336,39.0655251 C336,39.4590323 336.31902,39.7785425 336.713017,39.7785425 L340.040432,39.7785425 L344.051951,43.7895717 C344.501324,44.2389442 345.269226,43.9209041 345.269226,43.285804 L345.269226,38.1790313 L345.269226,32.8208647 L345.269226,27.7140919 C345.269226,27.0794819 344.501324,26.7609518 344.051951,27.2103243" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const MuteOn = props => (
  <SvgIcon width={20} height={17} {...props} viewBox="0 0 20 17">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-376.000000, -460.000000)" fill="#7C859D">
        <g transform="translate(40.000000, 132.000000)">
          <g transform="translate(0.000000, -7.000000)">
            <g transform="translate(0.000000, 310.344322)">
              <g transform="translate(336.000000, 24.000000)">
                <path d="M8.05195122,0.866001944 L4.04043198,4.87801123 L0.713017408,4.87801123 C0.31902016,4.87801123 0,5.19703139 0,5.59102864 L0,12.7212027 C0,13.1147099 0.31902016,13.4342201 0.713017408,13.4342201 L4.04043198,13.4342201 L8.05195122,17.4452493 C8.5013237,17.8946218 9.2692263,17.5765817 9.2692263,16.9414817 L9.2692263,11.8347089 L9.2692263,6.47654236 L9.2692263,1.36976957 C9.2692263,0.735159574 8.5013237,0.416629461 8.05195122,0.866001944" />
                <polygon
                  transform="translate(15.369828, 9.900166) rotate(135.000000) translate(-15.369828, -9.900166) "
                  points="16.9991133 4.90016633 13.7437574 4.90016633 13.7437574 8.27340859 10.3698276 8.27340859 10.3698276 11.5281294 13.7437574 11.5281294 13.7437574 14.9001663 16.9954958 14.9001663 16.9991133 11.5281294 20.3698276 11.5281294 20.3698276 8.27340859 16.9991133 8.27340859"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Password = props => (
  <SvgIcon width={19} height={24} {...props} viewBox="8 4 19 24">
    <path d="M25.347432,27 L9.34743202,27 C8.96676737,27 8.69486405,26.6727273 8.69486405,26.3454545 L8.69486405,12.6545455 C8.69486405,12.2727273 9.02114804,12 9.34743202,12 L25.347432,12 C25.7280967,12 26,12.3272727 26,12.6545455 L26,26.3454545 C26,26.7272727 25.673716,27 25.347432,27 Z M10,25.6363636 L24.6404834,25.6363636 L24.6404834,13.3090909 L10,13.3090909 L10,25.6363636 Z M22.2247244,13 L12.6962339,13 C12.371399,13 12.046564,12.7131108 12.046564,12.3688438 C11.8300074,9.78684135 12.371399,7.83599503 13.6165994,6.5736827 C15.4573306,4.68021421 18.1101489,5.02448121 18.2184273,5.02448121 C19.7884626,5.19661471 21.0336631,5.8851487 21.8457504,7.03270536 C23.4157857,9.21306302 22.9285334,12.311466 22.9285334,12.4262217 C22.8202551,12.7704887 22.5495593,13 22.2247244,13 Z M13.3459037,11.5655542 L21.5750546,11.5655542 C21.6291938,10.7048867 21.5750546,9.04092952 20.7088282,7.83599503 C20.1132975,7.03270536 19.192932,6.51630487 18.0018706,6.4015492 C17.9477315,6.4015492 15.8363046,6.17203787 14.4828258,7.54910586 C13.6707386,8.46715119 13.2917645,9.78684135 13.3459037,11.5655542 Z" />
  </SvgIcon>
)

export const Pdf = props => (
  <SvgIcon width="18" height="22" {...props} viewBox="0 0 18 22">
    <defs>
      <rect id="b" width="401.91" height="316" x="998" y="237" rx="5" />
      <filter
        id="a"
        width="102.7%"
        height="103.5%"
        x="-1.4%"
        y="-1.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.14 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1023 -314)" />
      <g fillRule="nonzero">
        <path
          fill="#E9E9E0"
          d="M12.676 0H.803C.473 0 .205.257.205.757v20.85c0 .136.267.393.598.393h16.394c.33 0 .598-.257.598-.393V5.1c0-.274-.038-.362-.105-.427L12.93.101A.37.37 0 0 0 12.676 0z"
        />
        <path fill="#D9D7CA" d="M12.886.06v4.654h4.848z" />
        <path
          fill="#CC4B4C"
          d="M5.528 13.092a.675.675 0 0 1-.395-.129c-.426-.306-.483-.648-.456-.88.074-.64.898-1.31 2.448-1.991.615-1.295 1.2-2.89 1.55-4.224-.409-.853-.805-1.96-.516-2.61.101-.227.228-.401.464-.477.093-.03.329-.067.415-.067.207 0 .388.255.516.412.121.148.395.46-.152 2.672.551 1.094 1.333 2.208 2.081 2.971.537-.093.998-.14 1.374-.14.64 0 1.029.143 1.187.438.131.245.077.53-.16.849a1.1 1.1 0 0 1-.908.468c-.497 0-1.076-.302-1.722-.898-1.16.233-2.516.649-3.612 1.109-.342.696-.67 1.258-.975 1.67-.419.563-.78.827-1.139.827zm1.09-2.014c-.875.472-1.231.86-1.257 1.078-.004.036-.015.131.176.272.061-.019.417-.175 1.08-1.35zm5.578-1.745c.334.246.415.37.633.37.096 0 .369-.003.495-.173a.614.614 0 0 0 .094-.163c-.05-.025-.117-.077-.48-.077-.207 0-.467.009-.742.043zM9.14 6.747a27.276 27.276 0 0 1-1.094 2.972 21.065 21.065 0 0 1 2.658-.794A13.446 13.446 0 0 1 9.14 6.747zm-.248-3.324c-.04.013-.544.69.04 1.263.387-.83-.022-1.269-.04-1.263zM17.197 22H.803a.587.587 0 0 1-.598-.575v-6.104h17.59v6.104a.587.587 0 0 1-.598.575z"
        />
        <g fill="#FFF">
          <path d="M4.657 20.821h-.67v-3.958h1.185c.175 0 .348.027.52.08.171.054.325.135.461.242.136.107.246.237.33.39.084.152.126.322.126.513 0 .2-.035.382-.106.545-.07.163-.17.3-.297.41a1.35 1.35 0 0 1-.458.258c-.179.061-.377.092-.593.092h-.498v1.428zm0-3.47v1.569h.616a.758.758 0 0 0 .243-.04.618.618 0 0 0 .221-.132.64.64 0 0 0 .162-.255 1.164 1.164 0 0 0 .034-.628.631.631 0 0 0-.358-.435.936.936 0 0 0-.414-.078h-.504zM10.726 18.732a2.8 2.8 0 0 1-.11.835 2.04 2.04 0 0 1-.276.58 1.395 1.395 0 0 1-.378.369c-.14.09-.275.156-.405.201-.13.045-.25.074-.358.086a2.48 2.48 0 0 1-.24.018H7.397v-3.958H8.64c.346 0 .651.053.914.158.263.106.481.247.654.422.174.175.303.375.39.599.085.223.128.454.128.69zM8.735 20.35c.455 0 .783-.14.984-.419.201-.28.302-.684.302-1.214 0-.164-.02-.328-.061-.489a1.032 1.032 0 0 0-.238-.437 1.256 1.256 0 0 0-.478-.317c-.201-.08-.462-.121-.783-.121h-.392v2.997h.666zM12.382 17.352v1.246h1.722v.44h-1.722v1.783h-.683v-3.958h2.578v.489z" />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Pencil = props => (
  <SvgIcon
    color={colorMap.dodgerBlue}
    fillRule="nonzero"
    width={17}
    height={17}
    {...props}
    stroke="none"
    viewBox="0 0 17 17"
  >
    <path d="M10.734 3.303a.381.381 0 0 0-.534 0L1.894 11.56a.381.381 0 0 0 0 .534l2.915 2.963a.381.381 0 0 0 .534 0L13.649 6.8a.381.381 0 0 0 0-.534l-2.915-2.963zm.097 1.554l-6.265 6.266a.381.381 0 0 1-.535 0 .381.381 0 0 1 0-.534l6.266-6.266a.381.381 0 0 1 .534 0 .381.381 0 0 1 0 .534zM1.166 12.629h-.049s-.048 0-.048.048L.34 16.126v.048l-.049.243a.369.369 0 0 0 .438.437l2.331-.583 1.36-.242s.049 0 .049-.049v-.049L1.166 12.63zM16.369 2.331L14.814.777c-.583-.583-1.603-.583-2.185 0l-.486.486-.874.874a.381.381 0 0 0 0 .534l2.914 2.963a.381.381 0 0 0 .534 0l.874-.874.729-.729c.534-.485.534-1.262.049-1.7z" />
  </SvgIcon>
)

export const People = props => (
  <SvgIcon width={137} height={134} {...props} viewBox="0 0 137 134">
    <g fill="none" fillRule="evenodd" transform="translate(.433)">
      <ellipse cx="68" cy="67" fill="#23A2F5" rx="68" ry="67" />
      <g strokeLinecap="round" strokeLinejoin="round">
        <path
          fill="#23A2F5"
          stroke="#C9E8FC"
          strokeWidth="3"
          d="M44.657 71c-6.727 0-12.18-5.373-12.18-12s5.453-12 12.18-12c6.726 0 12.179 5.373 12.179 12s-5.453 12-12.18 12zm-16.24 16c0-8.837 7.271-16 16.24-16 8.968 0 16.239 7.163 16.239 16H28.418zM91.343 71c-6.726 0-12.179-5.373-12.179-12s5.453-12 12.18-12c6.726 0 12.178 5.373 12.178 12S98.07 71 91.343 71zM75.104 87c0-8.837 7.27-16 16.24-16 8.968 0 16.238 7.163 16.238 16H75.104z"
        />
        <g transform="translate(28.418 41)">
          <path
            fill="#23A2F5"
            stroke="#FFF"
            strokeWidth="3"
            d="M40.093 30c-8.453 0-15.306-6.716-15.306-15 0-8.284 6.853-15 15.306-15s15.306 6.716 15.306 15c0 8.284-6.853 15-15.306 15zM18.746 51c0-11.322 9.365-20.5 20.918-20.5 11.552 0 20.917 9.178 20.917 20.5H18.746z"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Person = props => (
  <SvgIcon
    width={25}
    height={25}
    {...props}
    strokeWidth="0.2"
    viewBox="-3 -3 22 22"
  >
    <circle cx="7" cy="4" r="4" />
    <path d="M14 15a7 7 0 0 0-14 0h14z" />
  </SvgIcon>
)

export const Team = props => (
  <SvgIcon
    width={24}
    height={24}
    {...props}
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
  >
    <g id="Bounding_Box">
      <rect fill="none" width="24" height="24" />
    </g>
    <g id="Flat">
      <g id="ui_x5F_spec_x5F_header_copy_2" />
      <g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3
				C23,14.82,19.43,13.53,16.67,13.13z"
          />
        </g>
        <g>
          <circle fillRule="evenodd" clipRule="evenodd" cx="9" cy="8" r="4" />
        </g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24
				C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z"
          />
        </g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Phone = props => (
  <SvgIcon width={18} height={18} {...props} viewBox="0 0 18 18">
    <path d="M11.574 12.855a1 1 0 0 1-1.414 0L5.656 8.351a1 1 0 0 1 0-1.414l1.9-1.899L5.46 2.944a8.79 8.79 0 0 0-.824.95A11.427 11.427 0 0 0 3.082 6.74c-.33.731-.293 2.002.082 2.69l.05.103c.066.165.233.499.514.954a13.272 13.272 0 0 0 1.905 2.38 13.292 13.292 0 0 0 2.386 1.908c.458.283.794.452 1.05.56.712.375 1.995.416 2.689.082l.108-.044a11.35 11.35 0 0 0 2.75-1.515c.341-.258.657-.53.941-.817l-2.084-2.084-1.899 1.898zm1.192-4.02a1 1 0 0 1 1.414 0l3.453 3.453a1 1 0 0 1 .085 1.318 9.942 9.942 0 0 1-1.898 1.849 13.326 13.326 0 0 1-3.25 1.79c-1.274.585-3.184.516-4.343-.098-.984-.4-2.45-1.307-4.008-2.866-1.532-1.532-2.432-2.968-2.838-3.946C.728 9.09.682 7.197 1.225 6.003c.078-.224.226-.592.45-1.056.368-.768.821-1.536 1.365-2.257A9.977 9.977 0 0 1 4.895.784a1 1 0 0 1 1.318.084l3.464 3.463a1 1 0 0 1 0 1.415l-1.9 1.898 3.09 3.09 1.9-1.899z" />
  </SvgIcon>
)

export const PlusO = props => (
  <SvgIcon width={25} height={26} {...props} viewBox="0 0 25 26">
    <path
      fill="#4A90E2"
      fillRule="evenodd"
      d="M5.392 14.355v-3.43h5.392V5.531h3.432v5.392h5.392v3.431h-5.392v5.393h-3.432v-5.393H5.392zM25 12.64C25 5.736 19.404.14 12.5.14S0 5.736 0 12.64s5.596 12.5 12.5 12.5S25 19.544 25 12.64z"
    />
  </SvgIcon>
)

export const Plus = props => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </SvgIcon>
)

export const PlusCircle = props => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  </SvgIcon>
)

export const PlusCircleFull = props => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
  </SvgIcon>
)

export const Portfolio = props => (
  <SvgIcon width={23} height={21} {...props} viewBox="0 0 23 21">
    <path d="M18.937 16.16l-4.351 1.166a.85.85 0 0 1-1.042-.602l-.7-2.611a.852.852 0 0 1 .602-1.043l4.351-1.166a.851.851 0 0 1 1.042.603l.7 2.61a.85.85 0 0 1-.602 1.043zm-9.886-3.463a2.698 2.698 0 1 1 0-5.395 2.698 2.698 0 0 1 0 5.395zm12.608-7.799H1.142A1.14 1.14 0 0 0 0 6.038v13.42c0 .63.51 1.142 1.142 1.142h20.517c.63 0 1.141-.511 1.141-1.143V6.04c0-.63-.512-1.14-1.141-1.14zM8.512 1.902l.008-.008 5.788.002c0-.002.008.006.008.006l-.002 1.812h1.898l-.002-1.812A1.902 1.902 0 0 0 14.308 0H8.52c-1.054 0-1.9.854-1.903 1.902v1.812h1.895V1.902z" />
  </SvgIcon>
)

export const Print = props => (
  <SvgIcon width={20} height={18} {...props} viewBox="0 0 20 18">
    <path d="M2 7v6c0 .557.443 1 .995 1h14.01c.55 0 .995-.447.995-1V7c0-.557-.443-1-.995-1H2.995A.997.997 0 0 0 2 7zM0 7c0-1.657 1.34-3 2.995-3h14.01A2.992 2.992 0 0 1 20 7v6c0 1.657-1.34 3-2.995 3H2.995A2.992 2.992 0 0 1 0 13V7zm4 7v2h12v-2H4zm1-4h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm1 6h8v-4H6v4zM5 0h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm1 4h8V2H6v2z" />
  </SvgIcon>
)

export const Program = props => (
  <SvgIcon width={22} height={21} {...props} viewBox="0 0 22 21">
    <path d="M2 16.381v1.982c0 .01 0 .01.01.01h1.98c.01 0 .01 0 .01-.01V16.38c0-.009 0-.009-.01-.009H2.01c-.01 0-.01 0-.01.01zm10-4.009v2c1.107.005 2 .896 2 2.01v1.98c0 1.112-.893 2.01-2.01 2.01h-1.98A2.004 2.004 0 0 1 8 18.362v-1.98c0-1.109.888-2.005 2-2.01v-2H4.505a.498.498 0 0 0-.505.5v1.5c1.107.005 2 .896 2 2.01v1.98c0 1.112-.893 2.01-2.01 2.01H2.01A2.004 2.004 0 0 1 0 18.362v-1.98c0-1.109.888-2.005 2-2.01v-1.5c0-1.383 1.117-2.5 2.505-2.5H10v-2H8.998A3 3 0 0 1 6 5.374V3.37A2.993 2.993 0 0 1 8.998.372h4.004A3 3 0 0 1 16 3.37v2.004a2.993 2.993 0 0 1-2.998 2.998H12v2h5.495a2.499 2.499 0 0 1 2.505 2.5v1.5c1.107.005 2 .896 2 2.01v1.98c0 1.112-.893 2.01-2.01 2.01h-1.98a2.004 2.004 0 0 1-2.01-2.01v-1.98c0-1.109.888-2.005 2-2.01v-1.5c0-.278-.223-.5-.505-.5H12zm-2 4.01v1.98c0 .01 0 .01.01.01h1.98c.01 0 .01 0 .01-.01v-1.98c0-.01 0-.01-.01-.01h-1.98c-.01 0-.01 0-.01.01zM8 3.37v2.004a1 1 0 0 0 .998.998h4.004A.993.993 0 0 0 14 5.374V3.37a1 1 0 0 0-.998-.998H8.998A.993.993 0 0 0 8 3.37zm10 13.011v1.982c0 .01 0 .01.01.01h1.98c.01 0 .01 0 .01-.01V16.38c0-.009 0-.009-.01-.009h-1.98c-.01 0-.01 0-.01.01z" />
  </SvgIcon>
)

export const ProgramCode = props => (
  <SvgIcon width={22} height={21} {...props} viewBox="0 0 22 21">
    <path d="M5.584 10.175h1.484V2.963H5.584v7.212zm2.886 0h.901V2.963H8.47v7.212zm-5.3 0h.957V2.963H3.17v7.212zm1.43 0h.446V2.963H4.6v7.212zm7.954 5.248h-1.161v-1.472H6.609v1.472H5.45c-.765 0-1.383.627-1.383 1.39 0 .01 9.87.01 9.87 0 0-.763-.618-1.39-1.382-1.39zm-2.225-5.248h1.485V2.963h-1.485v7.212zm4.694-7.212h-.957v3.296l.957.59V2.963zm-13.61 8.692h15.175V1.413H1.413v10.242zM17.293 0H.708A.708.708 0 0 0 0 .707v11.656c0 .378.307.706.707.706h16.587c.393 0 .706-.32.706-.706V.707A.71.71 0 0 0 17.294 0zm-4.076 5.794V2.963h-.446v2.809c.145-.023.294-.017.446.022zm.188 3.743c.042.17.272.211.368.058l.327-.523.76 1.053c.065.089.192.112.282.044l.28-.201a.2.2 0 0 0 .044-.283L14.71 8.64l.598-.154a.202.202 0 0 0 .056-.368L13.048 6.69a.202.202 0 0 0-.302.221l.66 2.626z" />
  </SvgIcon>
)

export const Projects = props => (
  <SvgIcon width={20} height={22} {...props} viewBox="0 0 20 22">
    <path d="M2 8.996v8.008A2.994 2.994 0 0 0 4.993 20h6.014A2.994 2.994 0 0 0 14 17.004V8.996A2.994 2.994 0 0 0 11.007 6H4.993A2.994 2.994 0 0 0 2 8.996zm-2 0A4.994 4.994 0 0 1 4.993 4h6.014A4.994 4.994 0 0 1 16 8.996v8.008A4.994 4.994 0 0 1 11.007 22H4.993A4.994 4.994 0 0 1 0 17.004V8.996zM8.993 2a1 1 0 1 1 0-2h6.014A4.994 4.994 0 0 1 20 4.996v8.008a1 1 0 0 1-2 0V4.996A2.994 2.994 0 0 0 15.007 2H8.993zM4 10c0 .556.446 1 .997 1h6.006c.544 0 .997-.448.997-1 0-.556-.446-1-.997-1H4.997C4.453 9 4 9.448 4 10zm0 3c0 .556.446 1 .997 1h6.006c.544 0 .997-.448.997-1 0-.556-.446-1-.997-1H4.997C4.453 12 4 12.448 4 13zm0 3c0 .556.448 1 1 1h3c.556 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.556 0-1 .448-1 1z" />
  </SvgIcon>
)

export const QuestionMark = props => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
  </SvgIcon>
)

export const ScanCode = props => (
  <SvgIcon width="20px" height="16px" {...props} viewBox="0 0 20 16">
    <g stroke="none" strokeWidth="1">
      <g transform="translate(-24.000000, -29.000000)">
        <g id="user-dropdown" transform="translate(0.000000, 1.000000)">
          <g id="1" transform="translate(0.000000, 9.000000)">
            <path
              d="M30.2822575,32.6476628 L29.1991097,32.6476628 L29.1991097,34.8139585 L31.3654053,34.8139585 L31.3654053,33.7308107 L30.2822575,33.7308107 L30.2822575,32.6476628 Z M26.1662957,30.6979967 L27.032814,30.6979967 L27.032814,31.564515 L29.1991097,31.564515 L29.1991097,29.6148489 L30.2822575,29.6148489 L30.2822575,28.531701 L29.1991097,28.531701 L29.1991097,27.4485532 L28.1159618,27.4485532 L28.1159618,29.6148489 L24,29.6148489 L24,30.6979967 L25.0831478,30.6979967 L25.0831478,31.564515 L24,31.564515 L24,32.6476628 L25.0831478,32.6476628 L25.0831478,33.7308107 L24,33.7308107 L24,34.8139585 L26.1662957,34.8139585 L26.1662957,33.7308107 L28.1159618,33.7308107 L28.1159618,32.6476628 L26.1662957,32.6476628 L26.1662957,30.6979967 Z M24,28.531701 L25.0831478,28.531701 L25.0831478,27.4485532 L24,27.4485532 L24,28.531701 Z M41.2021208,31.8491662 C39.7667333,33.2845538 37.4392652,33.2845538 36.0038777,31.8491662 C34.5684901,30.4137787 34.5684901,28.0863106 36.0038777,26.6509231 C37.4392652,25.2151023 39.7667333,25.2151023 41.2021208,26.6509231 C42.6375083,28.0863106 42.6375083,30.4137787 41.2021208,31.8491662 L41.2021208,31.8491662 Z M42.4191457,25.4338982 C40.3117733,23.3260925 36.8942252,23.3260925 34.7868528,25.4338982 C32.679047,27.5417039 32.679047,30.9588187 34.7868528,33.0661912 C36.8942252,35.1739969 40.31134,35.1739969 42.4191457,33.0661912 C44.5269514,30.9588187 44.5269514,27.5417039 42.4191457,25.4338982 L42.4191457,25.4338982 Z M25.0831478,25.2822575 L30.2822575,25.2822575 L30.2822575,20.0831478 L25.0831478,20.0831478 L25.0831478,25.2822575 Z M24,26.3654053 L31.3654053,26.3654053 L31.3654053,19 L24,19 L24,26.3654053 Z M32.2215254,30.6979967 L30.2822575,30.6979967 L30.2822575,31.564515 L31.3654053,31.564515 L31.3654053,33.7308107 L32.4485532,33.7308107 L32.4485532,34.8139585 L35.2846675,34.8139585 C34.82238,34.597329 34.3865213,34.2749842 33.9887894,33.8772523 C33.0642144,32.9526773 32.4754153,31.7811446 32.2215254,30.6979967 L32.2215254,30.6979967 Z M34.6148489,20.0831478 L35.6979967,20.0831478 L35.6979967,19 L34.6148489,19 L34.6148489,20.0831478 Z M38.9474403,22.7294947 C39.1640698,22.7424924 39.597329,22.7845186 39.8139585,22.8555731 L39.8139585,19 L38.9474403,19 L38.9474403,20.0831478 L37.8642924,20.0831478 L37.8642924,20.9496661 L38.9474403,20.9496661 L38.9474403,22.7294947 Z M36.7811446,20.0831478 L37.8642924,20.0831478 L37.8642924,19 L36.7811446,19 L36.7811446,20.0831478 Z M26.1662957,24.1991097 L29.1991097,24.1991097 L29.1991097,20.9496661 L26.1662957,20.9496661 L26.1662957,24.1991097 Z M33.531701,24.1991097 L34.4320135,24.1991097 C35.4133455,23.3325914 36.564515,22.9292271 37.8642924,22.7771532 L37.8642924,20.9496661 L36.7811446,20.9496661 L36.7811446,22.032814 L34.6148489,22.032814 L34.6148489,20.9496661 L33.531701,20.9496661 L33.531701,19 L32.4485532,19 L32.4485532,23.1159618 L33.531701,23.1159618 L33.531701,24.1991097 Z M31.3654053,27.4485532 L31.3654053,29.6148489 L32.0850488,29.6148489 C32.0521211,28.7483306 32.1366066,28.0984419 32.3376388,27.4485532 L31.3654053,27.4485532 Z"
              id="Fill-1577"
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
)

export const Schedule = props => (
  <SvgIcon width={18} height={19} {...props} viewBox="0 0 18 19">
    <path
      fillRule="evenodd"
      d="M7.436 10.728h3.128V9.09H7.436v1.638zm0 5.271h3.128v-1.638H7.436V16zm-4.374-2.635h3.127v-1.638H3.062v1.638zM1.375 17.6h15.25V7.44H1.376V17.6zM17.312 2.08h-2.27v1.63c0 1.02-.825 1.844-1.843 1.847a1.846 1.846 0 0 1-1.845-1.847V2.08H6.6v1.63a1.847 1.847 0 0 1-3.693 0V2.08H.688A.69.69 0 0 0 0 2.77v15.517a.69.69 0 0 0 .688.688h16.624a.687.687 0 0 0 .688-.688V2.77a.687.687 0 0 0-.688-.688zM3.062 16h3.127V14.36H3.062V16zm4.374-2.636h3.128v-1.638H7.436v1.638zM4.753 4.585c.483 0 .875-.39.875-.874V.875a.875.875 0 1 0-1.75 0V3.71c0 .484.393.874.875.874zm8.446.001a.876.876 0 0 0 .874-.876V.874a.874.874 0 0 0-1.75 0V3.71c0 .484.393.876.876.876zm-1.389 6.142h3.128V9.09H11.81v1.638zm0 5.271h3.128v-1.638H11.81V16zm0-2.635h3.128v-1.638H11.81v1.638z"
    />
  </SvgIcon>
)

export const Search = props => (
  <SvgIcon width={19} height={19} {...props} viewBox="0 0 19 19">
    <path d="M16.03 14.616l1.92 1.92a.997.997 0 0 1 0 1.414.994.994 0 0 1-1.413 0l-1.921-1.92A8.96 8.96 0 0 1 9 18c-4.968 0-9-4.035-9-9 0-4.968 4.035-9 9-9 4.968 0 9 4.035 9 9a8.959 8.959 0 0 1-1.97 5.616zM2 9c0 3.86 3.137 7 7 7 3.86 0 7-3.137 7-7 0-3.86-3.137-7-7-7-3.86 0-7 3.137-7 7z" />
  </SvgIcon>
)

export const Settings = props => (
  <SvgIcon
    strokeWidth={2}
    width={20}
    height={20}
    {...props}
    viewBox="0 0 20 20"
  >
    <path
      fill="none"
      d="M15.415 7.413c.091.19.173.386.244.587h1.346C18.107 8 19 8.888 19 10c0 1.105-.893 2-1.995 2h-1.346c-.071.2-.153.397-.244.587l.952.952c.78.78.783 2.038-.003 2.825a1.997 1.997 0 0 1-2.825.003l-.952-.952c-.19.091-.386.173-.587.244v1.346A1.993 1.993 0 0 1 10 19c-1.105 0-2-.893-2-1.995v-1.346c-.2-.071-.397-.153-.587-.244l-.952.952c-.78.78-2.038.783-2.825-.003a1.997 1.997 0 0 1-.003-2.825l.952-.952A5.962 5.962 0 0 1 4.34 12H2.995A1.993 1.993 0 0 1 1 10c0-1.105.893-2 1.995-2h1.346c.071-.2.153-.397.244-.587l-.952-.952a1.993 1.993 0 0 1 .003-2.825 1.997 1.997 0 0 1 2.825-.003l.952.952c.19-.091.386-.173.587-.244V2.995C8 1.893 8.888 1 10 1c1.105 0 2 .893 2 1.995v1.346c.2.071.397.153.587.244l.952-.952a1.993 1.993 0 0 1 2.825.003c.781.781.783 2.045.003 2.825l-.952.952zM10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    />
  </SvgIcon>
)

export const Star = props => (
  <SvgIcon
    color={props.color || colorMap.brightSun}
    stroke={props.stroke || colorMap.neonCarrot}
    strokeWidth={1}
    width={14}
    height={13}
    {...props}
    viewBox="0 0 14 13"
  >
    <path d="M7.002 10.673l-2.61 1.372c-.977.514-1.617.047-1.431-1.039L3.459 8.1 1.348 6.04c-.79-.77-.544-1.523.546-1.681l2.918-.424L6.117 1.29c.489-.989 1.281-.988 1.769 0L9.19 3.936l2.918.424c1.092.158 1.335.912.546 1.681L10.544 8.1l.498 2.906c.187 1.088-.455 1.552-1.43 1.04l-2.61-1.373z" />
  </SvgIcon>
)

export const Tasks = props => (
  <SvgIcon width="24" height="24" {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </SvgIcon>
)

export const Timesheets = props => (
  <SvgIcon width="20" height="23" viewBox="0 0 20 23">
    <path
      fillRule="evenodd"
      d="M5.804 6.031h1.4V3.895c0-.025.006-.049.007-.073H4.066a.58.58 0 0 0-.58.579v8.74l2.318-1.437V6.03zm13.405-2.21h-3.146c0 .026.007.05.007.075L16.07 6.03h1.402v14.051l-11.667.02v-1.866l-2.317 1.437v2.248c0 .32.257.579.58.579h15.142c.313 0 .578-.25.578-.579V4.401a.578.578 0 0 0-.578-.58zm-7.623 6.389c0 .703.341 1.35 1.05 1.685 0 0 .585-1.087.721-1.35.137-.263.04-.397-.25-.387l-1.52.052zm-.55 2.496l-.083-.938-.818-.508-.108-.978-9.95 6.173c-.362 1.261.598 2.73 1.858 2.983l9.95-6.175-.849-.557zm-1.74-8.81c0-.026.011-.05.016-.074a.495.495 0 0 1 .488-.43h.354a1.829 1.829 0 0 0 2.966 0h.354c.31 0 .504.277.504.504v2.168H9.297V3.896zm1.688-1.662a.666.666 0 0 1 .653-.576c.406 0 .671.366.671.672a.67.67 0 0 1-.67.67.657.657 0 0 1-.654-.766zM8.717 7.222h5.84a.58.58 0 0 0 .58-.58c0-3.856 0-2.44-.008-2.82a1.657 1.657 0 0 0-1.672-1.588 1.84 1.84 0 0 0-.318-.933A1.812 1.812 0 0 0 11.637.5a1.815 1.815 0 0 0-1.502.8c-.183.27-.299.589-.317.934-.977 0-1.68.79-1.68 1.662v2.747c0 .316.254.579.58.579z"
    />
  </SvgIcon>
)

export const Trash = props => (
  <SvgIcon
    width={25}
    height={25}
    {...props}
    strokeWidth="0.2"
    viewBox="0 0 25 25"
  >
    <path d="M17.992 7.265h-2.93v-.488c0-.897-.703-1.63-1.562-1.63h-2.774c-.86 0-1.562.733-1.562 1.63v.488H6.273c-.234 0-.39.163-.39.408 0 .244.156.407.39.407h.703v9.573c0 1.222.938 2.2 2.11 2.2h6.171c1.172 0 2.11-.978 2.11-2.2V8.121h.625c.234 0 .39-.163.39-.408 0-.244-.156-.448-.39-.448zm-8.008-.488c0-.449.351-.815.781-.815h2.774c.43 0 .78.366.78.815v.488H9.985v-.488zm6.523 10.917c0 .733-.586 1.385-1.328 1.385H9.046c-.703 0-1.328-.611-1.328-1.385V8.12h8.79v9.573z" />
    <path d="M12.132 17.647c.22 0 .368-.163.368-.408V9.967c0-.245-.147-.408-.368-.408-.22 0-.367.163-.367.408v7.23c0 .246.147.45.367.45zM9.926 17.647c.221 0 .368-.163.368-.408V9.967c0-.245-.147-.408-.368-.408-.22 0-.367.163-.367.408v7.23c0 .246.147.45.367.45zM14.338 17.647c.22 0 .368-.163.368-.408V9.967c0-.245-.147-.408-.368-.408-.22 0-.367.163-.367.408v7.23c0 .246.147.45.367.45z" />
  </SvgIcon>
)

export const Txt = props => (
  <SvgIcon width="18" height="22" {...props} viewBox="0 0 18 22">
    <defs>
      <rect id="b" width="401.91" height="316" x="998" y="237" rx="5" />
      <filter
        id="a"
        width="102.7%"
        height="103.5%"
        x="-1.4%"
        y="-1.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.14 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1023 -461)" />
      <g fillRule="nonzero">
        <path
          fill="#E9E9E0"
          d="M12.676 0H.803C.473 0 .205.257.205.757v20.85c0 .136.267.393.598.393h16.394c.33 0 .598-.257.598-.393V5.1c0-.274-.038-.362-.105-.427L12.93.101A.37.37 0 0 0 12.676 0z"
        />
        <path fill="#D9D7CA" d="M12.886.06v4.654h4.848z" />
        <path
          fill="#95A5A5"
          d="M17.197 22H.803a.587.587 0 0 1-.598-.575v-6.104h17.59v6.104a.587.587 0 0 1-.598.575z"
        />
        <g fill="#FFF">
          <path d="M6.491 16.863v.44h-1.23v3.518h-.677v-3.518h-1.23v-.44zM9.181 18.898l1.046 1.923H9.45l-.655-1.493H8.74l-.704 1.493h-.777l1.046-1.923-1.113-2.035h.766l.727 1.611h.056l.789-1.611h.766zM14.125 16.863v.44h-1.23v3.518h-.677v-3.518h-1.23v-.44z" />
        </g>
        <path
          fill="#C8BDB8"
          d="M5.114 5.107H2.659a.401.401 0 0 1-.409-.393c0-.217.183-.393.41-.393h2.454c.226 0 .409.176.409.393a.401.401 0 0 1-.41.393zM6.34 7.071H2.66a.401.401 0 0 1-.41-.392c0-.217.183-.393.41-.393h3.68c.227 0 .41.176.41.393a.401.401 0 0 1-.41.392zM7.977 7.071a.439.439 0 0 1-.29-.114.383.383 0 0 1 .004-.558.436.436 0 0 1 .577 0 .405.405 0 0 1 .118.28.405.405 0 0 1-.118.278.44.44 0 0 1-.29.114zM12.886 7.071H9.614a.401.401 0 0 1-.41-.392c0-.217.183-.393.41-.393h3.272c.227 0 .41.176.41.393a.401.401 0 0 1-.41.392zM2.66 12.964a.439.439 0 0 1-.291-.114.403.403 0 0 1-.119-.279c0-.102.045-.204.119-.278a.437.437 0 0 1 .58.003c.074.071.12.173.12.275a.405.405 0 0 1-.12.28.44.44 0 0 1-.29.113zM7.568 12.964H4.295a.401.401 0 0 1-.409-.393c0-.216.183-.392.41-.392h3.272c.226 0 .41.176.41.392a.401.401 0 0 1-.41.393zM15.34 7.071h-.817a.401.401 0 0 1-.41-.392c0-.217.184-.393.41-.393h.818c.226 0 .409.176.409.393a.401.401 0 0 1-.41.392zM11.66 9.036h-9a.401.401 0 0 1-.41-.393c0-.217.183-.393.41-.393h9c.225 0 .408.176.408.393a.401.401 0 0 1-.409.393zM15.34 9.036h-2.454a.401.401 0 0 1-.409-.393c0-.217.183-.393.41-.393h2.454c.226 0 .409.176.409.393a.401.401 0 0 1-.41.393zM4.295 11H2.66a.401.401 0 0 1-.409-.393c0-.217.183-.393.41-.393h1.635c.227 0 .41.176.41.393a.401.401 0 0 1-.41.393zM10.023 11H5.932a.401.401 0 0 1-.41-.393c0-.217.184-.393.41-.393h4.09c.227 0 .41.176.41.393a.401.401 0 0 1-.41.393zM15.34 11h-3.68a.401.401 0 0 1-.41-.393c0-.217.183-.393.41-.393h3.68c.227 0 .41.176.41.393a.401.401 0 0 1-.41.393z"
        />
      </g>
    </g>
  </SvgIcon>
)

export const VideoCamera = props => (
  <SvgIcon width="24" height="24" {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
  </SvgIcon>
)

export const Xls = props => (
  <SvgIcon width="18" height="22" {...props} viewBox="0 0 18 22">
    <defs>
      <rect id="b" width="401.91" height="316" x="998" y="237" rx="5" />
      <filter
        id="a"
        width="102.7%"
        height="103.5%"
        x="-1.4%"
        y="-1.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.192156863 0 0 0 0 0.239215686 0 0 0 0 0.352941176 0 0 0 0.14 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1023 -350)" />
      <g fillRule="nonzero">
        <path
          fill="#E9E9E0"
          d="M12.676 0H.803C.473 0 .205.257.205.757v20.85c0 .136.267.393.598.393h16.394c.33 0 .598-.257.598-.393V5.1c0-.274-.038-.362-.105-.427L12.93.101A.37.37 0 0 0 12.676 0z"
        />
        <path fill="#D9D7CA" d="M12.886.06v4.654h4.848z" />
        <path
          fill="#91CDA0"
          d="M17.197 22H.803a.587.587 0 0 1-.598-.575v-6.104h17.59v6.104a.587.587 0 0 1-.598.575z"
        />
        <g fill="#FFF">
          <path d="M5.882 18.898l1.046 1.923h-.777l-.654-1.493H5.44l-.704 1.493h-.778l1.046-1.923-1.113-2.035h.766l.727 1.611h.056l.79-1.611h.765zM8.606 16.863v3.47h1.896v.488H7.924v-3.958zM13.517 19.736c0 .143-.03.282-.093.417a1.096 1.096 0 0 1-.26.354 1.25 1.25 0 0 1-.413.245 1.6 1.6 0 0 1-.56.09c-.09 0-.181-.004-.277-.013a2.332 2.332 0 0 1-.288-.045 1.552 1.552 0 0 1-.277-.09.894.894 0 0 1-.226-.136l.117-.462c.052.028.118.056.199.083.08.027.162.052.248.075.086.024.172.042.258.057.085.014.165.021.24.021.228 0 .402-.05.523-.153.121-.102.182-.253.182-.454a.426.426 0 0 0-.129-.311 1.389 1.389 0 0 0-.321-.234 7.74 7.74 0 0 0-.417-.21c-.15-.07-.29-.152-.42-.246a1.311 1.311 0 0 1-.324-.336.853.853 0 0 1-.128-.483c0-.175.033-.331.1-.467a1.05 1.05 0 0 1 .271-.347c.114-.094.247-.167.398-.217.15-.05.31-.075.478-.075.171 0 .345.015.52.045.175.03.316.08.425.148a5.144 5.144 0 0 1-.078.153l-.084.156a6.24 6.24 0 0 1-.1.174.683.683 0 0 1-.076-.042.59.59 0 0 0-.12-.054.89.89 0 0 0-.208-.038 2.036 2.036 0 0 0-.33.006.595.595 0 0 0-.213.061.735.735 0 0 0-.179.126.576.576 0 0 0-.123.17.475.475 0 0 0 .084.526c.085.088.192.165.319.231.126.067.264.131.414.193.149.063.288.14.417.229.128.089.235.201.321.335a.94.94 0 0 1 .13.518z" />
        </g>
        <path
          fill="#C8BDB8"
          d="M7.16 6.286V4.714H2.25V13.357h13.5V6.286H7.16zM3.067 5.5h3.273v.786H3.068V5.5zm0 1.571h3.273v.786H3.068v-.786zm0 1.572h3.273v.786H3.068v-.786zm0 1.571h3.273V11H3.068v-.786zm3.273 2.357H3.068v-.785h3.273v.785zm8.59 0H7.16v-.785h7.773v.785zm0-1.571H7.16v-.786h7.773V11zm0-1.571H7.16v-.786h7.773v.786zM7.16 7.857v-.786h7.773v.786H7.159z"
        />
      </g>
    </g>
  </SvgIcon>
)

export const MenuSettings = props => (
  <SvgIcon width="17" height="24" {...props} viewBox="0 0 17 24">
    <path
      fillRule="evenodd"
      d="M14.465 22.07l-1.574-1.231-1.595 1.247L9.7 20.84l-1.596 1.247L6.51 20.84l-1.595 1.247L3.32 20.84l-1.574 1.23V1.747h12.72V22.07zM15.338 0H.873A.873.873 0 0 0 0 .873L.001 22.62a.706.706 0 0 0 .274.545v.004l.759.593c.41.32.984.31 1.382 0l.904-.707.904.707c.407.317.975.317 1.382 0l.904-.707.905.707c.407.317.975.317 1.382 0l.904-.707.904.707c.407.317.975.317 1.382 0l.904-.707.904.707c.397.31.967.324 1.382 0l.76-.594v-.006a.704.704 0 0 0 .273-.545V.873A.873.873 0 0 0 15.339 0zM4.24 13.467h7.731v-1.745H4.24v1.745zM7.73 16.71h4.24v-1.746h-4.24v1.746zM4.24 6.983h7.731V5.237H4.24v1.746zm0 3.242h7.731V8.48H4.24v1.745z"
    />
  </SvgIcon>
)

export const PreferenceSettings = props => (
  <SvgIcon width="20" height="19" {...props} viewBox="0 0 20 19">
    <g fillRule="evenodd">
      <path d="M6.21 5c1.153 0 2.143-.598 2.595-1.458H18.81c.657 0 1.19-.467 1.19-1.042s-.533-1.042-1.19-1.042H8.805C8.353.598 7.363 0 6.21 0 5.058 0 4.067.598 3.616 1.458H1.19C.533 1.458 0 1.925 0 2.5s.533 1.042 1.19 1.042h2.426C4.067 4.402 5.058 5 6.21 5M8.115 18.75c1.153 0 2.143-.598 2.595-1.458h8.1c.657 0 1.19-.467 1.19-1.042s-.533-1.042-1.19-1.042h-8.1c-.452-.86-1.442-1.458-2.595-1.458-1.153 0-2.143.598-2.595 1.458H1.19c-.657 0-1.19.467-1.19 1.042s.533 1.042 1.19 1.042h4.33c.452.86 1.442 1.458 2.595 1.458M13.83 12.5c1.152 0 2.142-.598 2.594-1.458h2.386c.657 0 1.19-.467 1.19-1.042s-.533-1.042-1.19-1.042h-2.386c-.452-.86-1.442-1.458-2.594-1.458-1.153 0-2.144.598-2.595 1.458H1.19C.533 8.958 0 9.425 0 10s.533 1.042 1.19 1.042h10.045c.451.86 1.442 1.458 2.595 1.458" />
    </g>
  </SvgIcon>
)

export const FeatureSettings = props => (
  <SvgIcon width="20" height="20" {...props} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M19.22 10.909h-7.532a.78.78 0 0 0-.779.78v7.531c0 .43.349.78.78.78h7.532a.78.78 0 0 0 .779-.78v-7.532a.78.78 0 0 0-.78-.78M19.22 0h-7.532c-.43 0-.779.348-.779.78V8.31c0 .43.349.78.78.78h7.532c.43 0 .779-.35.779-.78V.78C20 .35 19.651 0 19.22 0M8.313 0H.779C.35 0 0 .348 0 .78V8.31c0 .43.349.78.78.78h7.532c.43 0 .779-.35.779-.78V.78C9.09.35 8.742 0 8.31 0m0 10.909H.78a.78.78 0 0 0-.779.78v7.531c0 .43.349.78.78.78h7.532a.78.78 0 0 0 .779-.78v-7.532a.78.78 0 0 0-.78-.78"
    />
  </SvgIcon>
)

export const CheckboxCircle = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </SvgIcon>
)

export const ManageSubscription = props => (
  <SvgIcon width="20" height="20" {...props} viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M16.378 7.165L8.896 14.62l-1.214-1.213.031-.028 2.49-2.49a.773.773 0 1 0-1.092-1.094l-2.49 2.491-.029.031-1.226-1.226 7.47-7.47c.773-.774 1.759-1.358 2.675-1.74 1.138.054 2.546 1.46 2.61 2.602-.388.925-.979 1.916-1.743 2.68m-.6 6.006c.033.903.06 1.617-.116 2.458-.147.698-.72 1.606-1.144 2.194a96.658 96.658 0 0 1-3.657-3.25l5.02-5.003c-.17 1.218-.145 2.5-.104 3.6m-13.6-7.687c.59-.424 1.497-.997 2.195-1.144 1.713-.36 3.462.14 6.054-.218L5.418 9.128a96.816 96.816 0 0 1-3.24-3.646M19.996 2.17C19.92.918 18.798.036 17.62.002c-1.225-.036-2.52.506-3.576 1.081-.71.387-1.42.875-2.008 1.432-1.493.636-3.555.61-5.16.55-.94-.036-1.76-.067-2.741.14-1.402.294-3.085 1.679-3.156 1.738a.58.58 0 0 0-.081.81c.018.023 3.7 4.195 3.7 4.195l-.665.666a.677.677 0 0 0 0 .956l4.485 4.484c.263.264.69.265.955.001l.667-.665s4.185 3.695 4.208 3.713a.58.58 0 0 0 .81-.08c.06-.072 1.444-1.755 1.739-3.156.206-.98.175-1.797.14-2.741-.061-1.604-.087-3.668.55-5.162 1.616-1.713 2.6-4.342 2.51-5.794M3.683 16.317c.011-.362.485-1.634 1.242-2.62l-1.144-1.145c-.683.197-1.542 1.003-1.959 1.488C.268 15.846-.08 19.396.015 19.985c.59.097 4.14-.253 5.945-1.807.484-.417 1.291-1.276 1.488-1.96l-1.144-1.143c-.987.758-2.259 1.23-2.621 1.242M14.58 3.452c-.435-.01-.827.134-1.103.404l-.021.022.716.715c.272-.245.798-.109 1.053.161l.02.02c.338.32.356.854.173 1.042l-.011.012.715.716.022-.02c.27-.277.413-.67.404-1.104a1.997 1.997 0 0 0-.596-1.373 1.995 1.995 0 0 0-1.372-.595"
    />
  </SvgIcon>
)

export const CompanyProfile = props => (
  <SvgIcon width="17" height="24" {...props} viewBox="0 0 17 24">
    <path
      fillRule="evenodd"
      d="M11.567 4.987l-.445-.458c-.185.115-.476.175-.782.175-1.005 0-1.676-.722-1.676-1.731 0-1.01.671-1.731 1.676-1.731s1.676.722 1.676 1.73c0 .46-.139.857-.384 1.158l.393.403-.458.454zm-3.79-.361h-1.02v-1.31H5.633v1.31H4.614V1.32h1.018v1.148h1.126V1.32h1.018v3.306zm6.19-3.363A1.263 1.263 0 0 0 12.704 0H3.798a1.265 1.265 0 0 0-1.262 1.263v4.834h11.431V1.263zm-3.627.803c-.26 0-.657.17-.657.907 0 .736.398.907.657.907a.498.498 0 0 0 .134-.018l-.277-.287.458-.445.278.283c.041-.116.065-.26.065-.44 0-.736-.399-.907-.658-.907zm1.16 10.49h2.582V9.971h-2.581v2.583zm0 4.446h2.582v-2.583h-2.581v2.583zm0 4.522h2.582v-2.582h-2.581v2.582zm-4.582-8.969h2.583V9.972H6.918v2.583zm0 4.447h2.583v-2.583H6.918v2.583zm-4.58-4.447h2.578V9.972H2.337v2.583zm0 4.447h2.578v-2.583H2.337v2.583zm0 4.522h2.578v-2.582H2.337v2.582zM14.68 7.467H1.823A1.827 1.827 0 0 0 0 9.29V24h6.918v-5.091h2.583V24h7.002V9.29a1.825 1.825 0 0 0-1.822-1.823z"
    />
  </SvgIcon>
)
